import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  transform: translateX(-50%) translateY(-50%);
`

export default class StaticArrow extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="21"
          height="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.321 17.774a.67.67 0 0 1-.546.226h-.974c-.408 0-.501-.29-.227-.562l7.738-7.678H.454C.159 9.76 0 9.603 0 9.31v-.62c0-.293.159-.45.454-.45h17.858L10.574.562C10.3.29 10.393 0 10.8 0h.974c.228 0 .387.067.546.226l8.525 8.459c.205.203.205.427 0 .63l-8.525 8.46z"
            fill="#FFF"
            fillRule="evenodd"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Hero/StaticArrow.js